export default "__VITE_ASSET__ia4e1X6G__"